import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.model && _ctx.model.Id ? "Edit Language" : "Add Language"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            ref: "frmRegister",
            modelValue: _ctx.valid,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.valid) = $event)),
            "lazy-validation": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoBox, { title: "Add your language here" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AutoCompleteField, {
                        readonly: _ctx.isHiringmanager,
                        dense: "",
                        label: "Language",
                        placeholder: "Select Language...",
                        modelValue: _ctx.model.Language,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.Language) = $event)),
                        items: _ctx.languages,
                        outlined: "",
                        rules: [_ctx.rules.required]
                      }, null, 8, ["readonly", "modelValue", "items", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12 pb-0" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("span", { class: "f-body-1" }, "Skill Level", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio_group, {
                        readonly: _ctx.isHiringmanager,
                        class: "mt-0",
                        rules: [_ctx.rules.required],
                        modelValue: _ctx.model.Level,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.Level) = $event)),
                        column: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            label: "Basic",
                            value: "Basic"
                          }),
                          _createVNode(_component_v_radio, {
                            label: "Intermediate",
                            value: "Intermediate"
                          }),
                          _createVNode(_component_v_radio, {
                            label: "Advanced",
                            value: "Advanced"
                          }),
                          _createVNode(_component_v_radio, {
                            label: "Native",
                            value: "Native"
                          })
                        ]),
                        _: 1
                      }, 8, ["readonly", "rules", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TextAreaField, {
                        readonly: _ctx.isHiringmanager,
                        modelValue: _ctx.model.Description,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.Description) = $event)),
                        outlined: "",
                        label: "Description",
                        placeholder: "Description"
                      }, null, 8, ["readonly", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "justify-end" }, {
        default: _withCtx(() => [
          (!_ctx.isHiringmanager)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "secondary_btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel())),
                loading: _ctx.loading,
                "prepend-icon": "mdi-cancel"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Cancel")
                ])),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.isHiringmanager)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                class: "primary_btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save())),
                loading: _ctx.loading,
                "prepend-icon": "mdi-check"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add Language" : "Save Language"), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}